import React from "react";
import BrandCard from "./BrandCard";
import SubTiltle from "./../Layout/SubTitle";
import { Container, Row } from "react-bootstrap";
import UseAllBrands from "../../CustomHooks/Brands/UseAllBrands";

const BrandFeatured = ({ title, btntitle }) => {
  const [loading, allBrands, pageCount, onPress, SearchValue, ChangeInputSearch] = UseAllBrands();
  return (
    <Container>
      {allBrands && allBrands.length > 0 ? (
        <div>
          <SubTiltle title={title} btntitle={btntitle} pathlink="/allbrand" />
          <Row className="mt-1 mb-5 d-flex justify-content-between">
            {allBrands ? (
              allBrands.slice(0, 4).map((item, index) => {
                let imageUrl = item.image;
                if (imageUrl.startsWith('http://127.0.0.1:8000/brands/http://127.0.0.1:8000/brands/http://127.0.0.1:8000/brands/')) {
                  imageUrl = imageUrl.replace('http://127.0.0.1:8000/brands/http://127.0.0.1:8000/brands/', '');
                }
                else if (imageUrl.startsWith('http://127.0.0.1:8000/brands/http://127.0.0.1:8000/brands/')) {
                  imageUrl = imageUrl.replace('http://127.0.0.1:8000/brands/', '');
                }
                else if (imageUrl.startsWith('http://127.0.0.1:8000/brands/http://127.0.0.1:8000/brands/http://127.0.0.1:8000/brands/http://127.0.0.1:8000/brands/')) {
                  imageUrl = imageUrl.replace('http://127.0.0.1:8000/brands/http://127.0.0.1:8000/brands/http://127.0.0.1:8000/brands/', '');
                }
                else {
                  imageUrl = item.image;
                }
                return (
                  <BrandCard
                    key={index}
                    img={imageUrl}
                    cardText={item.name}
                  />
                );
              })
            ) : (
              <h1>No Brands to show</h1>
            )}
          </Row>
        </div>
      ) : null}
    </Container>
  );
};

export default BrandFeatured;
